(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products"]) return;
  try {
    
  (function () {
    // ── Sort dropdown ──
    var sortBtn = document.querySelector('[data-sort-toggle]');
    var sortDropdown = document.querySelector('[data-sort-dropdown]');
    var sortLabel = document.querySelector('[data-sort-label]');
    var grid = document.querySelector('.product-grid');
    var paginationEl, tiles, originalOrder;

    if (grid) {
      paginationEl = grid.querySelector('.product-grid__pagination');
      tiles = Array.from(grid.querySelectorAll(':scope > .product-tile'));
      originalOrder = tiles.slice();
    }

    if (sortBtn && sortDropdown) {
      sortBtn.addEventListener('click', function () {
        var hidden = sortDropdown.getAttribute('aria-hidden') === 'true';
        sortDropdown.setAttribute('aria-hidden', String(!hidden));
        sortBtn.setAttribute('aria-expanded', String(hidden));
      });

      sortDropdown.querySelectorAll('[data-sort]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-sort');

          sortDropdown.setAttribute('aria-hidden', 'true');
          sortBtn.setAttribute('aria-expanded', 'false');

          if (sortLabel) sortLabel.textContent = btn.textContent.trim();
          sortDropdown.querySelectorAll('[data-sort]').forEach(function (b) {
            b.setAttribute('aria-current', b === btn ? 'true' : 'false');
          });

          if (!grid || !tiles) return;
          var sorted;
          if (val === 'price-ascending') {
            sorted = tiles.slice().sort(function (a, b) { return +a.dataset.price - +b.dataset.price; });
          } else if (val === 'price-descending') {
            sorted = tiles.slice().sort(function (a, b) { return +b.dataset.price - +a.dataset.price; });
          } else if (val === 'created-descending') {
            sorted = tiles.slice().sort(function (a, b) { return +b.dataset.created - +a.dataset.created; });
          } else {
            sorted = originalOrder.slice();
          }
          sorted.forEach(function (tile) {
            if (paginationEl) {
              grid.insertBefore(tile, paginationEl);
            } else {
              grid.appendChild(tile);
            }
          });
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortBtn.contains(e.target) && !sortDropdown.contains(e.target)) {
          sortDropdown.setAttribute('aria-hidden', 'true');
          sortBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // ── Filter drawer ──
    var filterOpenBtn = document.querySelector('[data-filter-open]');
    var filterDrawer = document.querySelector('[data-filter-drawer]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    var filterCloseBtn = document.querySelector('[data-filter-close]');
    var filterClearBtn = document.querySelector('[data-filter-clear]');
    var filterApplyBtn = document.querySelector('[data-filter-apply]');

    function openFilter() {
      filterDrawer.setAttribute('aria-hidden', 'false');
      filterOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeFilter() {
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function applyClientFilter() {
      var active = Array.from(document.querySelectorAll('[data-filter-vendor]:checked')).map(function (el) {
        return el.getAttribute('data-filter-vendor');
      });
      if (!tiles) return;
      tiles.forEach(function (tile) {
        tile.hidden = active.length > 0 && !active.includes(tile.dataset.vendor);
      });
    }

    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilter);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilter);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', function () {
        document.querySelectorAll('[data-filter-vendor]').forEach(function (cb) { cb.checked = false; });
        if (tiles) tiles.forEach(function (tile) { tile.hidden = false; });
        closeFilter();
      });
    }

    if (filterApplyBtn) {
      filterApplyBtn.addEventListener('click', function () {
        applyClientFilter();
        closeFilter();
      });
    }

    // ── Accordion ──
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.setAttribute('aria-hidden', String(expanded));
      });
    });

    // ── Show more ──
    document.querySelectorAll('[data-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.closest('.filter-accordion__panel-inner').querySelectorAll('.filter-accordion__option--extra').forEach(function (opt) {
          opt.classList.toggle('is-visible', !expanded);
        });
      });
    });

    // ── Quick-add ──
    var CHECK_SVG = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-quick-add-btn]');
        var originalHTML = btn.innerHTML;
        var variantId = (new FormData(form)).get('id');
        if (!variantId || !window.cartDrawer) { form.submit(); return; }
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return window.cartDrawer._fetchAndRender(); })
          .then(function () {
            btn.innerHTML = CHECK_SVG;
            setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 1200);
            window.cartDrawer._openOnly();
          })
          .catch(function () { btn.disabled = false; btn.innerHTML = originalHTML; form.submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // ── Sort dropdown ──
    var sortBtn = document.querySelector('[data-sort-toggle]');
    var sortDropdown = document.querySelector('[data-sort-dropdown]');

    if (sortBtn && sortDropdown) {
      sortBtn.addEventListener('click', function () {
        var hidden = sortDropdown.getAttribute('aria-hidden') === 'true';
        sortDropdown.setAttribute('aria-hidden', String(!hidden));
        sortBtn.setAttribute('aria-expanded', String(hidden));
      });

      sortDropdown.querySelectorAll('[data-sort]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', btn.getAttribute('data-sort'));
          window.location.href = url.toString();
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortBtn.contains(e.target) && !sortDropdown.contains(e.target)) {
          sortDropdown.setAttribute('aria-hidden', 'true');
          sortBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // ── Filter drawer ──
    var filterOpenBtn = document.querySelector('[data-filter-open]');
    var filterDrawer = document.querySelector('[data-filter-drawer]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    var filterCloseBtn = document.querySelector('[data-filter-close]');

    function openFilter() {
      filterDrawer.setAttribute('aria-hidden', 'false');
      filterOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeFilter() {
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilter);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilter);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

    // ── Accordion ──
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.setAttribute('aria-hidden', String(expanded));
          panel.style.display = expanded ? 'none' : '';
        }
      });
    });

    // ── Show more ──
    document.querySelectorAll('[data-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.closest('.filter-accordion__panel-inner').querySelectorAll('.filter-accordion__option--extra').forEach(function (opt) {
          opt.classList.toggle('is-visible', !expanded);
        });
      });
    });

    // ── Quick-add ──
    var CHECK_SVG = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-quick-add-btn]');
        var originalHTML = btn.innerHTML;
        if (!window.cartDrawer) { form.submit(); return; }
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () { return window.cartDrawer._fetchAndRender(); })
          .then(function () {
            btn.innerHTML = CHECK_SVG;
            setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 1200);
            window.cartDrawer._openOnly();
          })
          .catch(function () { btn.disabled = false; btn.innerHTML = originalHTML; form.submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CHECK_SVG = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('[data-quick-add-fcg]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-quick-add-fcg-btn]');
        var originalHTML = btn.innerHTML;
        if (!window.cartDrawer) { form.submit(); return; }
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () { return window.cartDrawer._fetchAndRender(); })
          .then(function () {
            btn.innerHTML = CHECK_SVG;
            setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 1200);
            window.cartDrawer._openOnly();
          })
          .catch(function () { btn.disabled = false; btn.innerHTML = originalHTML; form.submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-footer-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.setAttribute('aria-hidden', String(expanded));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-mobile-nav]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var mainPanel = nav && nav.querySelector('[data-mobile-panel="main"]');

    if (!nav || !openBtn) return;

    var backdrop = nav.querySelector('[data-mobile-close]');

    function openMenu() {
      nav.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      openBtn.setAttribute('aria-label', 'Close navigation');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          nav.querySelectorAll('.mobile-nav__item').forEach(function (item) {
            item.classList.add('is-visible');
          });
        });
      });
    }

    function closeMenu() {
      nav.querySelectorAll('.mobile-nav__item').forEach(function (item) {
        item.classList.remove('is-visible');
      });
      nav.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.setAttribute('aria-label', 'Open navigation');
      document.body.style.overflow = '';
      setTimeout(function () {
        nav.querySelectorAll('[data-mobile-panel]').forEach(function (p) {
          p.classList.remove('is-pushed', 'is-active');
        });
      }, 500);
    }

    openBtn.addEventListener('click', function () {
      if (nav.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') {
        closeMenu();
        openBtn.focus();
      }
    });

    nav.querySelectorAll('[data-open-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = btn.getAttribute('data-open-panel');
        var subPanel = nav.querySelector('[data-mobile-panel="' + panelId + '"]');
        if (mainPanel) mainPanel.classList.add('is-pushed');
        if (subPanel) subPanel.classList.add('is-active');
      });
    });

    nav.querySelectorAll('[data-mobile-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var subPanel = btn.closest('.mobile-nav__panel--sub');
        if (subPanel) subPanel.classList.remove('is-active');
        if (mainPanel) mainPanel.classList.remove('is-pushed');
      });
    });

    // Desktop nav dropdown keyboard accessibility + hover-intent
    var DROPDOWN_CLOSE_DELAY = 250;

    document.querySelectorAll('.nav-item--has-dropdown').forEach(function (item) {
      var trigger = item.querySelector('.nav-item__link');
      if (!trigger) return;

      // Plain CSS :hover closes the instant the pointer leaves the item's box,
      // which is too strict when moving the mouse down into a mega dropdown.
      // Add a short grace period so brief gaps don't close the menu early.
      var closeTimer;

      item._closeDropdownNow = function () {
        clearTimeout(closeTimer);
        // Suppress the fade-out transition so the previous dropdown vanishes
        // immediately instead of cross-fading with the one opening next.
        item.classList.add('dropdown-no-transition');
        item.classList.remove('is-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            item.classList.remove('dropdown-no-transition');
          });
        });
      };

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        // Close any other open dropdown immediately so it doesn't linger
        // and overlap while the pointer moves across the nav bar.
        document.querySelectorAll('.nav-item--has-dropdown.is-open').forEach(function (other) {
          if (other !== item) other._closeDropdownNow();
        });
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
        }, DROPDOWN_CLOSE_DELAY);
      });

      item.addEventListener('focusin', function () {
        trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });

    // Search drawer
    var searchDrawer = document.querySelector('[data-search-drawer]');
    var searchInput = document.querySelector('[data-search-input]');

    if (searchDrawer) {
      function openSearch() {
        searchDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (searchInput) {
          setTimeout(function () { searchInput.focus(); }, 50);
        }
      }

      function closeSearch() {
        searchDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      document.querySelectorAll('[data-search-open]').forEach(function (btn) {
        btn.addEventListener('click', openSearch);
      });

      searchDrawer.querySelectorAll('[data-search-close]').forEach(function (el) {
        el.addEventListener('click', closeSearch);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchDrawer.getAttribute('aria-hidden') === 'false') {
          closeSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  'use strict';

  var pd = window.__pd;
  if (!pd) return;

  var selectedOpts = pd.selectedOpts.slice();

  /* ── Helpers ── */
  function findVariant(opts) {
    return pd.variants.find(function (v) {
      return opts.every(function (o, i) { return v.options[i] === o; });
    });
  }

  function fmtARS(cents) {
    var ars = Math.round(cents * pd.arsRate / 100);
    return new Intl.NumberFormat('es-AR').format(ars);
  }

  /* Fetch live official dollar rate with localStorage cache (4-hour TTL).
     The official rate updates once per business day, so 4 h is a good
     trade-off: at most ~2 API calls per day per browser, always fresh. */
  (function fetchOfficialRate() {
    var CACHE_KEY = 'kx_oficial_rate';
    var CACHE_TTL = 4 * 60 * 60 * 1000; /* 4 hours in ms */

    function applyRate(rate, cachedAt) {
      if (!rate || isNaN(rate)) return;
      pd.arsRate = rate;
      var arsEl = document.getElementById('pd-price-ars');
      if (!arsEl) return;
      var cents = parseInt(arsEl.dataset.cents, 10);
      if (isNaN(cents)) return;
      var ageMs = Date.now() - cachedAt;
      var ageH  = Math.floor(ageMs / 3600000);
      var ageTxt = ageH >= 1 ? ' · actualizado hace ' + ageH + 'h' : '';
      arsEl.innerHTML =
        '$' + fmtARS(cents) + ' ARS' +
        ' <span class="pd__price-ars-est">estimado · dólar oficial $' +
        new Intl.NumberFormat('es-AR').format(Math.round(rate)) +
        ageTxt + '</span>';
    }

    /* Try cache first */
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && (Date.now() - cached.ts) < CACHE_TTL) {
        applyRate(cached.rate, cached.ts);
        return; /* fresh enough — skip network call */
      }
    } catch (e) {}

    /* Cache miss or expired — fetch */
    fetch('https://dolarapi.com/v1/dolares/oficial')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var rate = data.venta;
        if (!rate || isNaN(rate)) return;
        var ts = Date.now();
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ rate: rate, ts: ts })); } catch (e) {}
        applyRate(rate, ts);
      })
      .catch(function() { /* keep fallback rate silently */ });
  })();

  function fmtUSD(cents) {
    var dollars = cents / 100;
    return (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)) + ' USD';
  }

  function el(id) { return document.getElementById(id); }
  function isDesktop() { return window.innerWidth > 750; }

  /* ── Update UI after variant change ── */
  function updateVariant(variant) {
    if (!variant) return;

    /* Price */
    var usdEl = el('pd-price-usd');
    if (usdEl) {
      var onSale = variant.compare_at_price > variant.price;
      usdEl.classList.toggle('pd__price-usd--sale', onSale);
      if (onSale) {
        usdEl.innerHTML = '<s class="pd__price-compare">' + fmtUSD(variant.compare_at_price) + '</s>' +
          '<span class="pd__price-current">' + fmtUSD(variant.price) + '</span>';
      } else {
        usdEl.textContent = fmtUSD(variant.price);
      }
    }

    var arsEl = el('pd-price-ars');
    if (arsEl) arsEl.innerHTML = '$' + fmtARS(variant.price) + ' ARS <span class="pd__price-ars-est">estimado</span>';

    var stickyPriceEl = el('pd-sticky-price');
    if (stickyPriceEl) stickyPriceEl.textContent = fmtUSD(variant.price);

    /* Hidden variant input */
    var varInput = el('pd-variant-id');
    if (varInput) varInput.value = variant.id;

    /* ATC button */
    var atcBtn = el('pd-atc-btn');
    var stickyAtc = el('pd-sticky-atc');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
    }
    if (stickyAtc) stickyAtc.disabled = !variant.available;

    /* Buy now button */
    var buynowBtn = el('pd-buynow-btn');
    if (buynowBtn) buynowBtn.disabled = !variant.available;

    /* Low stock */
    var lowStock = el('pd-low-stock');
    if (lowStock) {
      var showLow = variant.inv_mgmt && variant.inv_qty === 1;
      lowStock.classList.toggle('is-hidden', !showLow);
    }

    /* Option labels */
    updateLabels();

    /* WA link */
    updateWALinks();
  }

  function updateLabels() {
    var sizeLabel = el('pd-size-label');
    if (sizeLabel !== null) {
      if (pd.sizeIdx !== null) sizeLabel.textContent = selectedOpts[pd.sizeIdx] || '';
    }
    var condLabel = el('pd-cond-label');
    if (condLabel !== null) {
      if (pd.condIdx !== null) condLabel.textContent = (selectedOpts[pd.condIdx] || '').toUpperCase();
    }

    var stickyAttrs = el('pd-sticky-attrs');
    if (stickyAttrs) {
      var parts = [];
      if (pd.sizeIdx !== null) parts.push(selectedOpts[pd.sizeIdx]);
      if (pd.condIdx !== null) parts.push(selectedOpts[pd.condIdx]);
      stickyAttrs.textContent = parts.filter(Boolean).join(' · ');
    }
  }

  function updateWALinks() {
    var sizeVal = pd.sizeIdx !== null ? (selectedOpts[pd.sizeIdx] || '') : '';
    var msg = encodeURIComponent('Hola! Quisiera consultar disponibilidad de talle ' + sizeVal + ' para: ' + pd.title);
    var waReq = el('pd-wa-request');
    if (waReq) waReq.href = 'https://wa.me/' + pd.wa + '?text=' + msg;

    var modalMsg = encodeURIComponent('Hola! Quisiera consultar medidas exactas para: ' + pd.title);
    var modalWa = el('sizing-modal-wa');
    if (modalWa) modalWa.href = 'https://wa.me/' + pd.wa + '?text=' + modalMsg;
  }

  /* ── Pill clicks ── */
  document.querySelectorAll('.pd__pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIdx = parseInt(this.dataset.opt, 10);
      var val = this.dataset.val;
      selectedOpts[optIdx] = val;

      document.querySelectorAll('.pd__pill[data-opt="' + optIdx + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('is-selected');
      this.setAttribute('aria-pressed', 'true');

      var variant = findVariant(selectedOpts);
      updateVariant(variant);
    });
  });

  /* ── Quantity ── */
  var qtyInput = el('pd-qty');
  var qtyMinus = el('pd-qty-minus');
  var qtyPlus = el('pd-qty-plus');
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* ── Buy now ── */
  var buynowBtn = el('pd-buynow-btn');
  if (buynowBtn) {
    buynowBtn.addEventListener('click', function () {
      var variantId = el('pd-variant-id') ? el('pd-variant-id').value : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;
      buynowBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        buynowBtn.disabled = false;
      });
    });
  }

  /* ── Image gallery ── */
  var slides = document.querySelectorAll('.pd__slide');
  var thumbBtns = document.querySelectorAll('.pd__thumb');
  var galleryPrev = el('pd-gallery-prev');
  var galleryNext = el('pd-gallery-next');
  var currentSlideIdx = 0;

  function updateArrows() {
    if (galleryPrev) galleryPrev.classList.toggle('is-hidden', currentSlideIdx === 0);
    if (galleryNext) galleryNext.classList.toggle('is-hidden', currentSlideIdx >= slides.length - 1);
  }

  var slideAnimTimer = null;
  var animClasses = ['is-entering-next', 'is-entering-prev', 'is-exiting-next', 'is-exiting-prev'];

  function goToSlide(idx) {
    if (idx === currentSlideIdx) return;
    var prevIdx = currentSlideIdx;
    var direction = idx > prevIdx ? 'next' : 'prev';
    currentSlideIdx = idx;

    if (slideAnimTimer) { clearTimeout(slideAnimTimer); slideAnimTimer = null; }

    slides.forEach(function (s) {
      s.classList.remove('is-active');
      animClasses.forEach(function (c) { s.classList.remove(c); });
    });

    var entering = direction === 'next' ? 'is-entering-next' : 'is-entering-prev';
    var exiting  = direction === 'next' ? 'is-exiting-next'  : 'is-exiting-prev';

    if (slides[idx])     slides[idx].classList.add('is-active', entering);
    if (slides[prevIdx]) slides[prevIdx].classList.add(exiting);

    slideAnimTimer = setTimeout(function () {
      slides.forEach(function (s) {
        animClasses.forEach(function (c) { s.classList.remove(c); });
      });
      slideAnimTimer = null;
    }, 320);

    thumbBtns.forEach(function (t) { t.classList.remove('is-active'); });
    document.querySelectorAll('.pd__thumb[data-thumb="' + idx + '"]').forEach(function (t) {
      t.classList.add('is-active');
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    updateArrows();
  }

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      goToSlide(parseInt(this.dataset.thumb, 10));
    });
  });

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function () {
      if (currentSlideIdx > 0) goToSlide(currentSlideIdx - 1);
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', function () {
      if (currentSlideIdx < slides.length - 1) goToSlide(currentSlideIdx + 1);
    });
  }

  updateArrows();

  /* Keyboard arrow navigation on gallery */
  document.addEventListener('keydown', function (e) {
    if (lightbox && lightbox.open) return; /* lightbox handles its own keys */
    if (e.key === 'ArrowLeft' && currentSlideIdx > 0) goToSlide(currentSlideIdx - 1);
    if (e.key === 'ArrowRight' && currentSlideIdx < slides.length - 1) goToSlide(currentSlideIdx + 1);
  });

  /* Touch swipe on main image for mobile */
  var mainWrap = el('pd-main-wrap');
  if (mainWrap) {
    var touchStartX = 0;
    mainWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      var next = diff > 0 ? currentSlideIdx + 1 : currentSlideIdx - 1;
      if (next >= 0 && next < slides.length) goToSlide(next);
    }, { passive: true });
  }

  /* ── Lightbox ── */
  var lightbox = el('pd-lightbox');
  var lightboxImg = el('pd-lightbox-img');
  var lightboxClose = el('pd-lightbox-close');
  var lightboxPrev = el('pd-lightbox-prev');
  var lightboxNext = el('pd-lightbox-next');
  var expandBtn = el('pd-expand-btn');

  function getSlideSrc(idx) {
    var slide = slides[idx];
    if (!slide) return '';
    return slide.dataset.src || (slide.querySelector('img') ? slide.querySelector('img').src : '');
  }

  function openLightbox(idx) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = getSlideSrc(idx);
    lightboxImg.alt = slides[idx] ? (slides[idx].querySelector('img') ? slides[idx].querySelector('img').alt : '') : '';
    lightbox.showModal();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.close();
  }

  if (expandBtn) {
    expandBtn.addEventListener('click', function () {
      openLightbox(currentSlideIdx);
    });
  }

  /* Also open on main image click on desktop */
  if (mainWrap) {
    mainWrap.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (e.target.closest('.pd__gallery-arrow') || e.target.closest('.pd__expand-btn')) return;
      openLightbox(currentSlideIdx);
    });
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    lightbox.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeLightbox();
    });
    /* Keyboard nav inside lightbox */
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && lightboxPrev) lightboxPrev.click();
      if (e.key === 'ArrowRight' && lightboxNext) lightboxNext.click();
    });
  }

  if (lightboxPrev) {
    lightboxPrev.addEventListener('click', function () {
      var prev = currentSlideIdx > 0 ? currentSlideIdx - 1 : slides.length - 1;
      goToSlide(prev);
      if (lightboxImg) lightboxImg.src = getSlideSrc(prev);
    });
  }

  if (lightboxNext) {
    lightboxNext.addEventListener('click', function () {
      var next = currentSlideIdx < slides.length - 1 ? currentSlideIdx + 1 : 0;
      goToSlide(next);
      if (lightboxImg) lightboxImg.src = getSlideSrc(next);
    });
  }

  /* ── Sticky nav ── */
  var stickyNav = el('pd-sticky');
  var pdInfo = el('pd-info');
  if (stickyNav && pdInfo) {
    var atcRow = document.querySelector('.pd__atc-row');

    function updateStickyNav() {
      var show = false;
      if (window.scrollY > 50 && atcRow) {
        var r = atcRow.getBoundingClientRect();
        var atcVisible = r.bottom > 0 && r.top < window.innerHeight;
        show = !atcVisible;
      }
      stickyNav.classList.toggle('is-visible', show);
      stickyNav.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', updateStickyNav, { passive: true });
  }

  /* ── Product form → AJAX add-to-cart ── */
  var pdForm = el('pd-form');
  if (pdForm) {
    pdForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = el('pd-variant-id');
      if (!variantInput || !window.cartDrawer) return;
      window.cartDrawer.addToCart(variantInput.value, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    });
  }

  /* Sticky ATC adds to cart via AJAX */
  var stickyAtcBtn = el('pd-sticky-atc');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      var variantInput = el('pd-variant-id');
      if (!variantInput || !window.cartDrawer) return;
      window.cartDrawer.addToCart(variantInput.value, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    });
  }

  /* ── Sizing modal ── */
  var sizingModal = el('sizing-modal');
  var sizingTrigger = el('pd-sizing-trigger');
  var sizingClose = el('sizing-modal-close');
  if (sizingModal && sizingTrigger) {
    function openSizing() {
      sizingModal.showModal();
      requestAnimationFrame(function () {
        sizingModal.classList.add('is-open');
      });
    }
    function closeSizing() {
      sizingModal.classList.remove('is-open');
      sizingModal.addEventListener('transitionend', function handler() {
        sizingModal.close();
        sizingModal.removeEventListener('transitionend', handler);
      });
    }
    sizingTrigger.addEventListener('click', openSizing);
    if (sizingClose) sizingClose.addEventListener('click', closeSizing);
    sizingModal.addEventListener('click', function (e) {
      if (e.target === sizingModal) closeSizing();
    });
    sizingModal.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeSizing();
    });
  }

  /* ── Related products carousel ── */
  var relatedTrack = el('related-track');
  if (relatedTrack) {
    var prevBtn = el('related-prev');
    var nextBtn = el('related-next');
    function updateRelatedNavState() {
      if (prevBtn) prevBtn.disabled = relatedTrack.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = relatedTrack.scrollLeft + relatedTrack.clientWidth >= relatedTrack.scrollWidth - 1;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { relatedTrack.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { relatedTrack.scrollBy({ left: 300, behavior: 'smooth' }); });
    relatedTrack.addEventListener('scroll', updateRelatedNavState);
    updateRelatedNavState();
  }

  /* Initial state */
  updateLabels();
  updateWALinks();

  /* Format initial ARS with Intl */
  var arsEl = el('pd-price-ars');
  if (arsEl) {
    var cents = parseInt(arsEl.dataset.cents, 10);
    if (!isNaN(cents)) {
      arsEl.innerHTML = '$' + fmtARS(cents) + ' ARS <span class="pd__price-ars-est">estimado</span>';
    }
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    // ── Filter drawer ──
    var filterOpenBtn = document.querySelector('[data-filter-open]');
    var filterDrawer = document.querySelector('[data-filter-drawer]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    var filterCloseBtn = document.querySelector('[data-filter-close]');

    function openFilter() {
      filterDrawer.setAttribute('aria-hidden', 'false');
      filterOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeFilter() {
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilter);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilter);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

    // ── Accordion ──
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.setAttribute('aria-hidden', String(expanded));
          panel.style.display = expanded ? 'none' : '';
        }
      });
    });

    // ── Show more ──
    document.querySelectorAll('[data-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.closest('.filter-accordion__panel-inner').querySelectorAll('.filter-accordion__option--extra').forEach(function (opt) {
          opt.classList.toggle('is-visible', !expanded);
        });
      });
    });

    // ── Sort dropdown ──
    var sortBtn = document.querySelector('[data-sort-toggle]');
    var sortDropdown = document.querySelector('[data-sort-dropdown]');

    if (sortBtn && sortDropdown) {
      sortBtn.addEventListener('click', function () {
        var hidden = sortDropdown.getAttribute('aria-hidden') === 'true';
        sortDropdown.setAttribute('aria-hidden', String(!hidden));
        sortBtn.setAttribute('aria-expanded', String(hidden));
      });

      sortDropdown.querySelectorAll('[data-sort]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', btn.getAttribute('data-sort'));
          window.location.href = url.toString();
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortBtn.contains(e.target) && !sortDropdown.contains(e.target)) {
          sortDropdown.setAttribute('aria-hidden', 'true');
          sortBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    var CHECK_SVG = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-quick-add-btn]');
        var originalHTML = btn.innerHTML;
        if (!window.cartDrawer) { form.submit(); return; }
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () { return window.cartDrawer._fetchAndRender(); })
          .then(function () {
            btn.innerHTML = CHECK_SVG;
            setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 1200);
            window.cartDrawer._openOnly();
          })
          .catch(function () { btn.disabled = false; btn.innerHTML = originalHTML; form.submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
